export interface Movie {
  id: string;
  title: string;
  genre: string;
  rating: number;
  year: number;
  duration: string;
  tagline: string;
  description: string;
  highlights: string[];
  poster: string;
}

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} 海报 电影推荐`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-background-50/90 font-heading text-xs font-bold text-accent-700">
            {rank}
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950">
          {movie.title}
        </h3>
        <p className="font-label text-xs text-foreground-600">
          {movie.genre} · {movie.year} · {movie.duration}
        </p>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {movie.tagline}
        </p>
      </div>
    </article>
  );
}